<template>
    <div ref="parentEl">
        <AppVsHero :data="heroContent" />

        <AppLandingOptions :title="t('pages_IR_options_title')" :data="optionSection" />

        <LazyAppFullWidthCompare :data="compareSlider" />

        <LazyAppLandingUploader service-slug="ir" />

        <LazyAppLandingPricingSection v-if="!useCookie('access_token').value" />

        <LazyAppApiAccess />

        <LazyAppExploreServices :items="aboutItems" />

        <LazyAppFaq :firstRow="faqFirstRow" :secondRow="faqSecondRow" />

        <LazyAppAboutService :item="aboutService" />

        <LazyAppPurpleCta :item="purpleCta" id="item-removal-lastsection-tryforfree" />

        <LazyAppUploaderBottomCta serviceSlug="ir" />
    </div>
</template>

<script setup lang="ts">
import { useItemRemovalContent } from "~/data/item-removal";

const {
    heroContent,
    itemRemovalSlides,
    aboutItems,
    personalSpacesSection,
    faqFirstRow,
    faqSecondRow,
    aboutService,
    optionSection,
    compareSlider,
    purpleCta,
} = useItemRemovalContent();

const { t } = useI18n();

// * seo
useHead({
    title: t("pages_IR_meta_title").replace("/", "|"),
    meta: [
        {
            name: "description",
            content: t("pages_IR_meta_desc"),
        },
    ],
    link: [
        {
            rel: "canonical",
            href: "" + useRoute().path,
        },
    ],
});
const parentEl = ref<HTMLElement | null>(null);
onMounted(() => {
    setTimeout(() => {
        parentEl.value?.classList.add("show-survey-landing-item-removal");
    }, 30000);
});
</script>
